import { useState } from 'react';
import PropTypes from 'prop-types';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
import { FEATURE_NAMES } from '../../../utils/constants';

const RoleTableRow = ({ role, isChecked, featureCount, features, onToggle }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <tr>
        <td>
          <input 
            type="checkbox" 
            checked={isChecked} 
            onChange={onToggle}
            className="role-row-checkbox"
            unselectable={role === "User" ? "on" : "off"}
            disabled={role === "User"}
          />
        </td>
        <td>{role}</td>
        <td>{featureCount}개 피처</td>
        <td>
          <button 
            className="btn-icon chevron-btn" 
            onClick={() => setIsExpanded(!isExpanded)}
            title={isExpanded ? '접기' : '펼치기'}
          >
            <ChevronDownIcon color='var(--gray-600)' style={{ transform: isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }} />
          </button>
        </td>
      </tr>
      {isExpanded && (
        <tr className="feature-detail-row">
          <td colSpan="4">
            <div className="feature-details">
              <div className="feature-details-header">
                <span className="text-b1-600 text-gray-900">피처 목록</span>
                <span className="badge badge-info">{features?.length || 0}개</span>
              </div>
              <div className="feature-list">
                {features && features.length > 0 ? (
                  features.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      <span className="feature-name">
                        {FEATURE_NAMES[feature] || feature}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="text-b2-400 text-gray-500">피처가 없습니다</div>
                )}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

RoleTableRow.propTypes = {
  role: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  featureCount: PropTypes.number.isRequired,
  features: PropTypes.arrayOf(PropTypes.string),
  onToggle: PropTypes.func.isRequired,
};

export default RoleTableRow;

